export default __webpack_public_path__ + "static/media/logo-main-white.39fbf55b.png";